import { useEffect, useState } from 'react'
import Landing from './pages/Landing'
import Agents from './pages/Agents'
import Faq from './pages/Faq'
import Find from './pages/Find'
import Login from './pages/Login'
import Plans from './pages/Plans'
import Signup from './pages/Signup'

// ponytail: 해시 라우팅. URL 파라미터가 필요해지면 react-router로 교체.
const PAGES = {
  '#/login': Login,
  '#/signup': Signup,
  '#/find': Find,
  '#/find/pw': Find,
  '#/plans': Plans,
  '#/agents': Agents,
  '#/faq': Faq,
} as const

export default function App() {
  const [hash, setHash] = useState(window.location.hash)

  useEffect(() => {
    const onChange = () => setHash(window.location.hash)
    window.addEventListener('hashchange', onChange)
    return () => window.removeEventListener('hashchange', onChange)
  }, [])

  // 다른 페이지에서 #features 같은 랜딩 앵커를 누르면 Landing이 아직 안 그려져 있어
  // 브라우저 기본 스크롤이 빗나간다. 렌더 후에 직접 맞춰준다.
  useEffect(() => {
    const el = document.getElementById(hash.slice(1))
    if (el) el.scrollIntoView()
    else window.scrollTo(0, 0)
  }, [hash])

  const Page = PAGES[hash as keyof typeof PAGES] ?? Landing
  return <Page />
}
